import { mutationTypes, getterTypes } from './store/types';
import { MODULE_NAME } from './constants/moduleConstants';
import { registerStore } from '@modules/common';
import store from '@modules/product-picker/store';
import ProductPicker from './components/ProductPicker.vue';

registerStore(MODULE_NAME, { store });

export default ProductPicker;
export { mutationTypes, getterTypes, MODULE_NAME };
